const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

if (!apiKey) {
  setTimeout(() => {
    throw new Error('Google Maps API key is missing');
  }, 0);
}

let googleMapsScriptPromise = null;

export const initGoogleMaps = () => {
  if (window.google && window.google.maps && window.google.maps.places) {
    return Promise.resolve();
  }
  if (googleMapsScriptPromise) {
    return googleMapsScriptPromise;
  }

  googleMapsScriptPromise = new Promise((resolve, reject) => {
    try {
      if (!apiKey) {
        throw new Error('Google Maps API key is missing');
      }
      // Remove any existing Google Maps script tags to avoid duplicates
      const existingScript = document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]');
      if (existingScript) {
        existingScript.parentNode.removeChild(existingScript);
      }
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places,geometry`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        resolve();
      };
      script.onerror = (error) => {
        setTimeout(() => {
          throw new Error('Failed to load Google Maps script');
        }, 0);
        googleMapsScriptPromise = null;
        reject(new Error('Failed to load Google Maps script'));
      };
      document.head.appendChild(script);
    } catch (error) {
      setTimeout(() => {
        throw error;
      }, 0);
      googleMapsScriptPromise = null;
      reject(error);
    }
  });
  return googleMapsScriptPromise;
}; 